import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Folder } from '@/types';

export const useFoldersStore = defineStore('folders', () => {
	const folders = ref<Folder[]>([]);
	const selectedFolder = ref<Folder | null>(null);
	const isLoading = ref(false);
	const error = ref<string | null>(null);
	const searchQuery = ref('');

	const setFolders = (data: Folder[]) => {
		folders.value = data;
	};

	const selectFolder = (folder: Folder) => {
		selectedFolder.value = folder;
	};

	const clearSelection = () => {
		selectedFolder.value = null;
	};

	return {
		folders,
		selectedFolder,
		isLoading,
		error,
		searchQuery,
		setFolders,
		selectFolder,
		clearSelection
	};
});
